module.exports = __webpack_public_path__ + "img/Ellipse.1d435899.svg";